import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";

// JSON
import aboutus from "../data/aboutus.json";
import imagesFT from "../data/imagesFT.json";

// Animation
import "animate.css";
import TrackVisibility from "react-on-screen";

// JS
import images from "../components/images"; 

export const Projects = () => {

  const projects = [
    {
      title: "Der Beelzebub 2013",
      description: "Wir lassen die Puppen tanzen!",
      imgUrl: images[imagesFT.beelzebub1],
    },
    {
      title: "Der Beelzebub 2020",
      description: "Jetzt geht's widder unter d'Lidd, denn isch Fasentszit 2020",
      imgUrl: images[imagesFT.beelzebub2],
    },
    {
      title: "",
      description: "",
      imgUrl: images[imagesFT.FelsenteufelAnonym],
    },
    {
      title: "",
      description: "",
      imgUrl: images[imagesFT.FelsenteufelAnonym],
    },
    {
      title: "",
      description: "",
      imgUrl: images[imagesFT.FelsenteufelAnonym],
    },
    {
      title: "",
      description: "",
      imgUrl: images[imagesFT.FelsenteufelAnonym],
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Über uns</h2>
                 <p>{aboutus.aboutus}</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="fifth">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Der Beelzebub</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Unser Häs</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Unser Karch</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="fourth">Termine</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="fifth">Teufelsball</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="sixth">Links</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second"> 
                      <p>Unser Häs besteht aus rotem Stoff, sowie grau roten Spättle. Die Maske besteht aus Holz und wurde von der Firma Pfaff-Masken hergestellt. Zum Häs gehören außerdem schwarze Handschuhe, ein Ledergürtel mit Schellen, sowie Schuhe die mit Hasenfell überzogen sind.</p>
                      <Row>
                        {/* Großes Bild oben */}
                        <Col md={12} className="mb-4">
                        <img src={images[imagesFT.unserhaes1]} alt="unserhaes1" className="img-fluid" />
                        </Col>
                    </Row>
                    <Row>
                        {/* Zwei kleinere Bilder unten */}
                        <Col md={6} className="mb-4">
                        <img src={images[imagesFT.unserhaes2]} alt="unserhaes2" className="img-fluid w-100" />
                        </Col>
                        <Col md={6} className="mb-4">
                        <img src={images[imagesFT.unserhaes3]} alt="unserhaes3" className="img-fluid w-100" style={{ height: '495px' }} />
                        </Col>
                    </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>Ob in Heidelberg beim Umzug oder am schmutzigen Donnerstag in Bühlertal, unser Karch darf einfach nicht fehlen. Es handelt sich um einen umgebauten Magirus-Deutz aus dem Jahre 1955. Der hintere Teil des Karchs stellt eine Felsenlandschaft dar, was auf unseren Namen zurückzuführen ist. Im Inneren befinden sich zwei große Kisten die vor Umzügen mit Konfetti befüllt werden. Vom Innenraum hat man außerdem die Möglichkeit auf das Dach zu gelangen. Hier kommt dann öfters unsere Konfetti Kanone zum Einsatz. Im Jahr 2014 stand nach 16 Jahren Treue eine umfassende Renovierung unseres Karchs auf dem Plan. So wurde das Blech bis zur Hälfte der Wagenhöhe abmontiert und die darunterliegende Stahlkonstruktion und die Wandbleche entrostet. Es wurde außerdem eine Konstruktion angebracht um das neugekaufte Stromaggregat unsichtbar hinter den Blechen verschwinden zu lassen. Unter großem Aufwand wurde dann alles wieder zusammengebaut.</p>
                          {/* Obere Reihe mit 3 Bildern */}
                    <Row className="mb-4">
                        <Col md={4} sm={12} className="mb-4">
                          <img src={images[imagesFT.Karch1]} alt="Karch1" className="img-fluid w-100" style={{ height: '600px' }} /> 
                        </Col>
                        <Col md={4} sm={12} className="mb-4">
                          <img src={images[imagesFT.Karch2]} alt="Karch2" className="img-fluid w-100" style={{ height: '600px' }} /> 
                       </Col>
                        <Col md={4} sm={12} className="mb-4">
                          <img src={images[imagesFT.Karch3]} alt="Karch3" className="img-fluid w-100" style={{ height: '600px' }} />
                        </Col>
                    </Row>
                    {/* Untere Reihe mit 2 Bildern */}
                    <Row>
                        <Col md={6} sm={12} className="mb-4">
                          <img src={images[imagesFT.Karch4]} alt="Karch4" className="img-fluid w-100" style={{ height: '500px' }} />
                        </Col>
                        <Col md={6} sm={12} className="mb-4">
                          <img src={images[imagesFT.Karch5]} alt="Karch5" className="img-fluid w-100" style={{ height: '500px' }} />
                        </Col>
                    </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="fourth">                   
                      <Row className="justify-content-center align-items-center" style={{ height: "100vh" }}>
                        <Col xs="auto">

                          <img src={images[imagesFT.kampangenplan]} alt="Kampagnenplan" style={{ width: "500px", height: "auto" }} />
                        
                        </Col>
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="fifth">
                    <Row className="justify-content-center align-items-center" style={{ height: '100vh' }}>
                        <Col xs="auto">
                          
                          <img src={images[imagesFT.teufelball]} alt="Teufelball" style={{ width: "500px", height: "auto" }} />
                         
                        </Col>
                    </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="sixth">
                    <Row>
                      <Col xs={6} className="text-center">
                        <div className="Links">
                          <p><a href="https://www.kellergnome.com/" target="_blank" rel="noopener noreferrer" className="styled-link">Bühlertäler Kellergnome e.V.</a></p>
                          <p><a href="https://bohnestaedtler.webnode.page/" target="_blank" rel="noopener noreferrer" className="styled-link">Bühlertäler Bohnestädtler e.V.</a></p>
                          <p><a href="https://www.waldmaennle.de/" target="_blank" rel="noopener noreferrer" className="styled-link">Bühlertäler Waldmännle e.V.</a></p>
                        </div>
                      </Col>

                      <Col xs={6} className="text-center">
                        <div className="Links">
                          <p><a href="https://www.elendshexen-buehlertal.com/" target="_blank" rel="noopener noreferrer" className="styled-link">Elends-Hexen Bühlertal e.V.</a></p>
                          <p><a href="https://gertelbach-daemonen.de/" target="_blank" rel="noopener noreferrer" className="styled-link">Gertelbach-Dämonen Bühlertal e.V.</a></p>
                          <p><a href="http://www.schwarzwaldhexen.com/" target="_blank" rel="noopener noreferrer" className="styled-link">Schwarzwaldhexen Bühlertal e.V.</a></p>
                        </div>
                      </Col>
                    </Row>
                    </Tab.Pane>

                    </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      
    </section>
  )
}